import { Starter } from '../../../../starters/types/StartersTypes';
import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface GetAllWorkbookStartersResult extends IResult{
  workbookTemplates: Starter[];
}

export class GetAllWorkbookStartersRequest
  extends Request<{}, GetAllWorkbookStartersResult>
{
  constructor() {
    super('getAllWorkbookTemplates', {});
  }
}
